import PropTypes from 'prop-types';
import classNames from 'classnames';
import Styles from './SkillSet.module.scss';

const Tags = ({ className, tags, style, count, isWp }) => {
  if (!tags.length) return null;

  const endIndex = (count && count > tags.length ? tags.length : count) || tags.length;
  const extractedTags = tags.slice(0, endIndex);

  return (
    <div
      className={classNames(Styles.container, isWp && Styles.wpContainer, className)}
      style={style}>
      {extractedTags.map((tag, j) => (
        <div key={j} className={Styles.item}>
          {isWp ? tag.name : tag}
        </div>
      ))}
    </div>
  );
};

Tags.propTypes = {
  className: PropTypes.string,
  tags: PropTypes.array,
  count: PropTypes.number,
  style: PropTypes.object,
  isWp: PropTypes.bool,
};

export default Tags;
